export default {
  Gradebook: "Zeugnis",
  Gradebooks: "Zeugnisse",
  edit_gradebook: "Zeugnisse eingeben",
  gradebook_finalization: "Zeugnisabschluss",
  empty_gradebook: "Es existiert derzeit kein Zeugnis",
  empty_gradebook_subject: "Für diesen Zeitraum ist kein Fach eingetragen",
  empty_gradebook_subject_exam: "Für dieses Fach ist keine Prüfung eingetragen",
  classroom: "Klasse",
  gradebook: {
    absent: "Abwesend",
    coefficient: {
      short: "Koeff",
    },
    mark: "Note",
    appreciation: "Beurteilung",
    appreciations: "Beurteilungen",
    success: "Ihre Änderung wurde erfolgreich verarbeitet!",
    min: "Min",
    max: "Max",
    average: {
      short: "Ø",
      session: "Durchschnitt im Zeitraum",
    },
    export: {
      excel: {
        title: "Zeugnis als Excel exportieren",
        confirmation: "Möchten Sie die Zeugnisse dieser Gruppe wirklich als Excel exportieren?",
      },
      pdf: {
        title: "Zeugnis als PDF exportieren",
        confirmation: "Möchten Sie das Zeugnis dieses Trinômes wirklich als PDF exportieren?",
        all: {
          title: "Alle Zeugnisse als PDF exportieren",
          confirmation: "Möchten Sie die Zeugnisse dieser Gruppe wirklich als PDF exportieren?",
        },
      },
    },
    comment: {
      title: "Beurteilung",
      general: "Allgemeine Beurteilung",
      placeholder: "Beurteilung hinzufügen (optional)",
    },
    session: {
      is_valid: "Dieser Zeitraum ist validiert, er ist für die Mitglieder der Trinômes sichtbar",
      is_not_valid: "Dieser Zeitraum ist noch nicht validiert, er ist für die Mitglieder der Trinômes nicht sichtbar",
      valid: "Noten des aktiven Zeitraums veröffentlichen",
      unlock: "Aktiven Zeitraum entsperren",
      valid_confirmation: "Möchten Sie die Eingabe des aktiven Zeitraums wirklich validieren?",
      unlock_confirmation: "Möchten Sie die Eingabe des aktiven Zeitraums wirklich entsperren?",
      valid_success: "Zeitraum erfolgreich veröffentlicht!",
      unlock_success: "Zeitraum erfolgreich entsperrt!",
      already_pulished: "Dieser Zeitraum ist bereits veröffentlicht, Sie können ihn nicht mehr bearbeiten",
      ended: "Dieser Zeitraum ist abgelaufen, er kann nicht mehr veröffentlicht werden",
    },
    triad: {
      unlock_entry: "Eingabe dieser Note entsperren",
      valid_entry: "Eingabe dieser Note validieren",
      valid_confirmation: "Möchten Sie die Eingabe dieser Note wirklich validieren?",
      unlock_confirmation: "Möchten Sie die Eingabe dieser Note wirklich entsperren?",
      valid_success: "Note erfolgreich validiert!",
      unlock_success: "Note erfolgreich entsperrt!",
      save_note: "Noteneingabe speichern",
    },
    exam_type: "Prüfungsart",
    percent: {
      title: "Prozentsatz der Prüfung",
      help: "Gewichtung der Prüfungsnote bei der Berechnung der Fachnote",
    },
    too_much_percent: "Die Summe der Prozentsätze der Prüfungen dieses Fachs muss 100 ergeben",
    percentage: {
      edit: {
        valid: "Prozenteingabe validieren",
        success: "Prozentsatz erfolgreich gespeichert!",
      },
    },
    ects: "ECTS-Credits",
    empty_subject: "Kein Fach eingetragen. Bitte fügen Sie zuerst eines hinzu, indem Sie hier klicken",
    exempt: "Befreit",
    reminder: {
      title: "Ausbilder erneut kontaktieren",
      confirmation: "Möchten Sie diesen Ausbilder wirklich erneut kontaktieren?",
      success: "Erneute Kontaktaufnahme erfolgreich!",
    },
    formers: {
      title: "Ausbilder",
    },
    write_by: ({ named }) => `Eingegeben von ${named("user")}`,
    write_on: ({ named }) => `, am ${named("date")}`,
    exemption: "Befreiung",
  },
};
